import { useRef, useState, useLayoutEffect, useCallback } from 'react';

import { GLOBAL } from 'saddlebag-browser';

export const useBadgeMultiline = (heightThreshold = 30) => {
  const badgeRef = useRef<HTMLDivElement>(null);
  const [isBadgeMultiline, setIsBadgeMultiline] = useState(false);

  const checkBadgeHeight = useCallback(() => {
    if (badgeRef.current) {
      // Check if the badge height exceeds the threshold
      // Single line badge height is typically 28px, multi-line would be > 30px
      const badgeHeight = badgeRef.current.offsetHeight;
      setIsBadgeMultiline(badgeHeight > heightThreshold);
    }
  }, [heightThreshold]);

  useLayoutEffect(() => {
    // Check height on mount
    checkBadgeHeight();
    // Store the window reference
    const saddlebagWindow = GLOBAL.getWindow();

    // Add resize listener to recalculate on viewport changes
    saddlebagWindow.addEventListener('resize', checkBadgeHeight);

    // Cleanup listener on unmount
    return () => {
      saddlebagWindow.removeEventListener('resize', checkBadgeHeight);
    };
  }, [checkBadgeHeight]);

  return { badgeRef, isBadgeMultiline };
};
